import { Accept } from "../../../shared";
import {
    Component,
    SessionService,
    WindowStateService,
    UrlService
} from "../../../core/index";

import styles from "./viabill-accept.scss";
import template from "./viabill-accept.html";

@Component({
    selector: "becViabillAccept",
    template
})
export class ViaBillAccept extends Accept {
    static $inject = [
        "SessionService",
        "UrlService",
        "$interval",
        "gettextCatalog",
        "WindowStateService"
    ];

    constructor(
        public session: SessionService,
        urlService: UrlService,
        $interval: ng.IIntervalService,
        gettextCatalog: ng.gettext.gettextCatalog,
        windowState: WindowStateService
    ) {
        super(session, urlService, $interval, gettextCatalog, windowState);

        this.session.status = "authorized";
        this.session.isAuthorized = true;
    }

    styles = styles;
}
